import Client from '@synapsestudios/fetch-client';

const unauthenticatedClient = new Client({
  //url: 'http://localhost:5000/',
  url: 'https://secret-refuge-24414.herokuapp.com/',
});

export default unauthenticatedClient;
